/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { BarWave } from 'react-cssfx-loading';
import { NavLink } from 'react-router-dom';
import parse from 'html-react-parser';
import Proptypes from 'prop-types';
// import { useGetArticlesQuery } from '../../redux/public/publicSlice';
import { useGetArticlesQuery } from '../../redux/apiSlice';
import LinkButton from '../../components/Buttons/LinkButton';
import usePagination from '../../components/Pagination/PaginationHook';
import Pagination from '../../components/Pagination/Pagination';
import banner from '../assets/images/banner.jpg';
import policy from '../assets/images/policy.jpg';

function AllArticles() {
  const {
    data: articles,
    isLoading: articlesLoadingStatus,
    isSuccess: articlesSuccessStatus,
    isError: articlesErrorStatus,
  } = useGetArticlesQuery();

  const {
    handleNext,
    handlePrevious,
    itemsDisplaying: articlesDisplaying,
  } = usePagination(articles, 5);

  let content;

  if (articlesLoadingStatus) {
    content = (
      <div
        className="bg-gray-900 bg-opacity-90 p-16 fixed z-50 w-full h-full top-0 left-0 flex flex-col items-center justify-center"
      >
        <BarWave color="#54c5fc" height="2rem" width="8rem" />
      </div>
    );
  } else if (articlesErrorStatus) {
    content = <div className="text-red-500">An error occurred while fetching this article</div>;
  } else if (articlesSuccessStatus) {
    content = (
      <>
        <div className="flex lg:flex-nowrap flex-wrap xl:px-24 lg:p-16 md:p-8 p-4 pt-16 bg-sky-50">
          <NavLink
            to={`/public/article/${articles[0].id}`}
            key={articles[0].id}
            className="lg:w-2/3 w-full lg:mr-16 md:pr-8 pr-4"
          >
            <h1 className="font-semibold xl:text-3xl lg:text-xl text-md text-gray-700 mb-8">FEATURED ARTICLE</h1>
            <h2 className="font-bold xl:text-xl lg:text-lg text-md text-gray-700 my-2 px-2 lg:mb-4 mb-2">
              {articles[0].post_title}
            </h2>
            <div className="px-2 flex items-center mb-2 gap-2">
              <h3 className="xl:text-lg lg:text-md md:text-sm text-xs text-blue-500">{`By ${articles[0].name} on `}</h3>
              <p className="text-gray-600  xl:text-lg lg:text-md text-xs">
                {new Date(articles[0].post_date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
            <p className="xl:text-lg lg:text-md md:text-sm text-xs text-gray-700 my-1 md:mb-8 mb-4 px-2">
              {parse(articles[0].post_content.length > 600
                ? `${articles[0].post_content.substring(0, 600)} [...]`
                : articles[0].post_content)}
            </p>
            <LinkButton path={`/public/article/${articles[0].id}`} linktext="Read More . . ." />
          </NavLink>
          <div className="lg:w-1/3 w-full bg-contain bg-no-repeat lg:mt-16 md:mt-8 mt-4 lg:h-auto md:h-60 h-48" style={{ backgroundImage: `url(${policy})` }}>.</div>
        </div>
        <div className="flex flex-col xl:px-24 lg:px-16 md:px-8 px-4 lg:mb-16 md:mb-8 mb-2">
          <h1 className="border-b border-gray-200 font-bold xl:text-2xl md:text-xl text-lg text-gray-800 py-4 md:my-8 my-2 w-full">Other Articles</h1>
          <div className="flex flex-col xl:gap-12 lg:gap-10 md:gap-6 gap-3">
            {articles.slice(articlesDisplaying - 4, articlesDisplaying).map((article) => (
              <NavLink
                to={`/public/article/${article.id}`}
                key={article.id}
                className="flex md:flex-nowrap flex-wrap"
              >
                <div className="md:w-1/3 w-full bg-contain bg-no-repeat md:mt-4 mt-2 md:h-auto h-36" style={{ backgroundImage: `url(${banner})` }}>
                  .
                </div>
                <div
                  className="md:w-2/3 w-full flex flex-col gap-1 xl:py-6 py-3 px-2 md:pl-6 hover:bg-sky-50"
                >
                  <div className="px-2 flex items-center mb-2 gap-2">
                    <h3 className="xl:text-lg lg:text-md text-sm text-blue-500">{`By ${article.name} on `}</h3>
                    <p className="text-gray-600 l:text-lg lg:text-md text-xs">
                      {new Date(article.post_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}
                    </p>
                  </div>
                  <h2 className="font-bold xl:text-xl lg:text-lg text-md text-gray-700 px-2 xl:mb-4 mb-1">
                    {article.post_title}
                  </h2>
                  <p className="xl:text-lg lg:text-md text-xs text-gray-700 my-1 xl:mb-8 md:mb-4 mb-2 px-2">
                    {parse(article.post_content.length > 300
                      ? `${article.post_content.substring(0, 300)} [...]`
                      : article.post_content)}
                  </p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
        <Pagination
          itemsDisplaying={articlesDisplaying}
          itemsPerPage={5}
          items={articles}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      </>
    );
  }
  return (
    <div className="xl:mt-24 lg:mt-16 mt-8 w-full">
      {content}
    </div>
  );
}

Proptypes.propTypes = {
  articles: Proptypes.isRequired,
};

export default AllArticles;
